import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { SocialProofBar } from '../components/SocialProofBar';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { PortfolioSection } from '../components/PortfolioSection';
import { GoogleProfilesSection } from '../components/GoogleProfilesSection';
import { PricingSection } from '../components/PricingSection';
import { ProcessSection } from '../components/ProcessSection';
import { StorySection } from '../components/StorySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FinalCTA } from '../components/FinalCTA';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { PromoPopup } from '../components/PromoPopup';
export function Home() {
  return <div className="min-h-screen bg-dark text-white font-sans selection:bg-gold selection:text-dark" data-id="element-481" data-mp="2vxf13sdmekbd">
      <Navbar data-id="element-482" data-mp="2qxke3zwyuevl" />
      <main data-id="element-483" data-mp="2qxapafnnqdrh">
        <Hero data-id="element-484" data-mp="2qwsi4nzgif4s" />
        <SocialProofBar data-id="element-485" data-mp="2r0gc1o8td3k1" />
        <ProblemSection data-id="element-486" data-mp="2mxa5efhshad1" />
        <MechanismSection data-id="element-487" data-mp="2mvyulvpxf2cf" />
        <PortfolioSection data-id="element-488" data-mp="2mwqqz8rcl43r" />
        <GoogleProfilesSection data-id="element-489" data-mp="2hxx974512qxs" />
        <PricingSection data-id="element-490" data-mp="2hy6zytxwd24j" />
        <ProcessSection data-id="element-491" data-mp="2hzi3qtrce9vn" />
        <StorySection data-id="element-492" data-mp="2hzqjcteuntaj" />
        <TestimonialsSection data-id="element-493" data-mp="2d7gwjm9179ch" />
        <GuaranteeSection data-id="element-494" data-mp="2d65qtgw0zriq" />
        <UrgencySection data-id="element-495" data-mp="2d5w2ryujjufo" />
        <FinalCTA data-id="element-496" data-mp="28840qc06mrxr" />
        <FAQSection data-id="element-497" data-mp="287ktpqc2lnyi" />
      </main>
      <Footer data-id="element-498" data-mp="288ni9rlx7eb9" />
      <FloatingWhatsApp data-id="element-499" data-mp="288dqbyhbex2x" />
      <PromoPopup data-id="element-500" data-mp="23916lmlqq64k" />
    </div>;
}